// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tLWq","content":"styles_content__KIEC6"};